export const NemaInsightsReport = () => {
  return (
    <svg width='40' height='40' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_40354_108484)'>
        <rect width='32' height='32' rx='16' fill='#FFF3DD' />
        <path d='M16.375 8.5H15.625V10H16.375V8.5Z' fill='#9A6412' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.25 19.148V19.75C18.25 20.1642 17.9142 20.5 17.5 20.5H14.5C14.0858 20.5 13.75 20.1642 13.75 19.75V19.148C12.4049 18.3699 11.5 16.9156 11.5 15.25C11.5 12.7647 13.5147 10.75 16 10.75C18.4853 10.75 20.5 12.7647 20.5 15.25C20.5 16.9156 19.5951 18.3699 18.25 19.148ZM16.75 18.2828L17.4989 17.8496C18.3995 17.3286 19 16.3585 19 15.25C19 13.5931 17.6569 12.25 16 12.25C14.3431 12.25 13 13.5931 13 15.25C13 16.3585 13.6005 17.3286 14.5011 17.8496L15.25 18.2828V19H16.75V18.2828Z'
          fill='#9A6412'
        />
        <path d='M17.5 21.25V23.5H14.5V21.25H17.5Z' fill='#9A6412' />
        <path d='M22.75 15.625H21.25V14.875H22.75V15.625Z' fill='#9A6412' />
        <path d='M10.75 15.625V14.875H9.25V15.625H10.75Z' fill='#9A6412' />
        <path d='M21.25 10L21.7803 10.5303L20.7197 11.591L20.1893 11.0607L21.25 10Z' fill='#9A6412' />
        <path d='M10.2197 10.5303L10.75 10L11.8107 11.0607L11.2803 11.591L10.2197 10.5303Z' fill='#9A6412' />
      </g>
      <defs>
        <clipPath id='clip0_40354_108484'>
          <rect width='32' height='32' rx='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
